import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';

import IntlMessages from 'util/IntlMessages';
import CustomScrollbars from 'util/CustomScrollbars';
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';


class SidenavContent extends Component {
  componentDidMount() {
    const { history } = this.props;
    const that = this;
    const pathname = `${history.location.pathname}`;// get current path

    const menuLi = document.getElementsByClassName('menu');
    for (let i = 0; i < menuLi.length; i++) {
      menuLi[i].onclick = function (event) {
        for (let j = 0; j < menuLi.length; j++) {
          const parentLi = that.closest(this, 'li');
          if (menuLi[j] !== this && (parentLi === null || !parentLi.classList.contains('open'))) {
            menuLi[j].classList.remove('open')
          }
        }
        this.classList.toggle('open');
      }
    }

    const activeLi = document.querySelector('a[href="' + pathname + '"]');// select current a element
    try {
      const activeNav = this.closest(activeLi, 'ul'); // select closest ul
      if (activeNav.classList.contains('sub-menu')) {
        this.closest(activeNav, 'li').classList.add('open');
      } else {
        this.closest(activeLi, 'li').classList.add('open');
      }
    } catch (error) {

    }
  }

  componentWillReceiveProps(nextProps) {

    const { history } = nextProps;
    const pathname = `${history.location.pathname}`;// get current path

    const activeLi = document.querySelector('a[href="' + pathname + '"]');// select current a element
    try {
      const activeNav = this.closest(activeLi, 'ul'); // select closest ul
      if (activeNav.classList.contains('sub-menu')) {
        this.closest(activeNav, 'li').classList.add('open');
      } else {
        this.closest(activeLi, 'li').classList.add('open');
      }
    } catch (error) {

    }
  }

  closest(el, selector) {
    try {
      let matchesFn;
      // find vendor prefix
      ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some(function (fn) {
        if (typeof document.body[fn] == 'function') {
          matchesFn = fn;
          return true;
        }
        return false;
      });

      let parent;

      // traverse parents
      while (el) {
        parent = el.parentElement;
        if (parent && parent[matchesFn](selector)) {
          return parent;
        }
        el = parent;
      }
    } catch (e) {

    }

    return null;
  }

  isRoleCheck = (roles, roleId) => {
    return roles.find(x => x.roleId === roleId) !== undefined
  }

  render() {

    const userRoles = this.props.authUser.userRoles;



    return (
      <CustomScrollbars className=" scrollbar">
        <ul className="nav-menu">


          <li className="nav-header">
            ANASAYFA
          </li>
          <li className="menu no-arrow">
            <NavLink to="/masal/sample-page">
              <i className="zmdi zmdi-home zmdi-hc-fw" />
              <span className="nav-text">Anasayfa</span>
            </NavLink>
          </li>
          {
            (this.isRoleCheck(userRoles, 13)) &&
            <>
              <li className="nav-header" >
                Masal İşlemlerİ
              </li>
              <li className="menu no-arrow">
                <NavLink to="/masal/approvedTalePage">
                  <i className="zmdi zmdi-assignment-check zmdi-hc-fw" />
                  <span className="nav-text">Onaylanan Masallar </span>
                </NavLink>
              </li>
              <li className="menu no-arrow">
                <NavLink to="/masal/rejectedTalePage">
                  <i className="zmdi zmdi-assignment-alert zmdi-hc-fw" />
                  <span className="nav-text">Reddedilen Masallar </span>
                </NavLink>
              </li>
              <li className="menu no-arrow">
                <NavLink to="/masal/publicTalePage">
                  <i className="zmdi zmdi-cast zmdi-hc-fw" />
                  <span className="nav-text">Yayınlanan Masallar </span>
                </NavLink>
              </li>
              <li className="menu no-arrow">
                <NavLink to="/masal/privateContentTalePage">
                  <i className="zmdi zmdi-tag-more zmdi-hc-fw" />
                  <span className="nav-text">Özel İçerik Masallar</span>
                </NavLink>
              </li>
              <li className="menu no-arrow">
                <NavLink to="/masal/withdrawnTalePage">
                  <i className="zmdi zmdi-rotate-right zmdi-hc-fw" />
                  <span className="nav-text">Geri Çekilen Masallar</span>
                </NavLink>
              </li>
              <li className="menu no-arrow">
                <NavLink to="/masal/noContractTalePage">
                  <i className="zmdi zmdi-file-text zmdi-hc-fw" />
                  <span className="nav-text">Taahhütname Dosyası Olmayan Masallar</span>
                </NavLink>
              </li>
              <li className="menu no-arrow">
                <NavLink to="/masal/rejectErrorTalePage">
                  <i className="zmdi zmdi-alert-polygon zmdi-hc-fw" />
                  <span className="nav-text">Editör Tarafından Reddedilen Masallar</span>
                </NavLink>
              </li>
              <li className="menu no-arrow">
                <NavLink to="/masal/correctionRequestedTalePage">
                  <i className="zmdi zmdi-comment-edit zmdi-hc-fw" />
                  <span className="nav-text">Düzeltme İstenen Masallar</span>
                </NavLink>
              </li>
              <li className="menu no-arrow">
                <NavLink to="/masal/otherTalesTalePage">
                  <i className="zmdi zmdi-format-list-numbered zmdi-hc-fw" />
                  <span className="nav-text">Diğer Masallar</span>
                </NavLink>
              </li>
            </>
          }

          {
            this.isRoleCheck(userRoles, 6) ?
              <li className="nav-header">
                <IntlMessages id="sidebar.admin" />
              </li>
              : null
          }



          {
            this.isRoleCheck(userRoles, 6) ?

              <li className="menu collapse-box">  <Button>
                <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                <span className="nav-text">
                  Admin İşleri
                </span>
              </Button>
                <ul className="sub-menu">
                  <li className="menu no-arrow">
                    <NavLink to="/masal/users">
                      <i className="zmdi zmdi-account zmdi-hc-fw" />
                      <span className="nav-text"><IntlMessages id="pages.usersPage" /> </span>
                    </NavLink>
                  </li>
                  <li className="menu no-arrow">
                    <NavLink to="/masal/institutions">
                      <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                      <span className="nav-text"><IntlMessages id="pages.insPage" /> </span>
                    </NavLink>
                  </li>
                  <li className="menu no-arrow">
                    <NavLink to="/masal/taleList">
                      <i className="zmdi zmdi-dns zmdi-hc-fw" />
                      <span className="nav-text"> Masallar </span>
                    </NavLink>
                  </li>
                  {/* <li className="menu no-arrow">
    <NavLink to="/masal/paymentsAdmin">
      <i className="zmdi zmdi-money zmdi-hc-fw"/>
      <span className="nav-text"> Ödemeler </span>
    </NavLink>
  </li> */}
                  <li className="menu no-arrow">
                    <NavLink to="/masal/editorList">
                      <i className="zmdi zmdi-accounts-outline zmdi-hc-fw" />
                      <span className="nav-text"> Editörler </span>
                    </NavLink>
                  </li>
                  <li className="menu no-arrow">
                    <NavLink to="/masal/taleManagement">
                      <i className="zmdi zmdi-globe-alt zmdi-hc-fw" />
                      <span className="nav-text"> Masal Yönetim </span>
                    </NavLink>
                  </li>
                  <li className="menu no-arrow">
                    <NavLink to="/masal/statistics">
                      <i className="zmdi zmdi-globe-alt zmdi-hc-fw" />
                      <span className="nav-text"> İstatistikler</span>
                    </NavLink>
                  </li>
                  <li className="menu no-arrow">
                    <NavLink to="/masal/appSettings">
                      <i className="zmdi zmdi-smartphone-iphone zmdi-hc-fw" />
                      <span className="nav-text"> Masal Masal Türkiye</span>
                    </NavLink>
                  </li>
                  <li className="menu no-arrow">
                    <NavLink to="/masal/appSettingsNew">
                      <i className="zmdi zmdi-smartphone-iphone zmdi-hc-fw" />
                      <span className="nav-text"> Türk Dünyası Masalları</span>
                    </NavLink>
                  </li>
                </ul>
              </li>

              : null
          }


          {
            this.isRoleCheck(userRoles, 2) || this.isRoleCheck(userRoles, 3) || this.isRoleCheck(userRoles, 4) || this.isRoleCheck(userRoles, 5) || this.isRoleCheck(userRoles, 7) || this.isRoleCheck(userRoles, 8) || this.isRoleCheck(userRoles, 9) ?
              [<li className="nav-header" key="1">
                EDİTÖR
              </li>,

              <li className="menu collapse-box" key="2">  <Button>
                <i className="zmdi zmdi-border-color zmdi-hc-fw" />
                <span className="nav-text">
                  Editör İşleri
                </span>
              </Button>
                <ul className="sub-menu">
                  <li className="menu no-arrow">
                    <NavLink to="/masal/taleListInbox">
                      <i className="zmdi zmdi-dns zmdi-hc-fw" />
                      <span className="nav-text"> Bekleyen İşlerim </span>
                    </NavLink>
                  </li>
                  {this.isRoleCheck(userRoles, 7) || this.isRoleCheck(userRoles, 5) ?
                    <li className="menu no-arrow">
                      <NavLink to="/masal/advisoryBoardTaleDataTable">
                        <i className="zmdi zmdi-blur zmdi-hc-fw" />
                        <span className="nav-text"> Danışma Kurulu </span>
                      </NavLink>
                    </li> : null}
                  <li className="menu no-arrow">
                    <NavLink to="/masal/searchTale">
                      <i className="zmdi zmdi-search zmdi-hc-fw" />
                      <span className="nav-text"> Detaylı Arama </span>
                    </NavLink>
                  </li>
                  {/* <li className="menu no-arrow">
        <NavLink to="/masal/payments">
          <i className="zmdi zmdi-money zmdi-hc-fw"/>
          <span className="nav-text"> Ödemelerim </span>
        </NavLink>
      </li> */}
                  <li className="menu no-arrow">
                    <NavLink to="/masal/writtenPubRequest">
                      <i className="zmdi zmdi-assignment-check zmdi-hc-fw" />
                      <span className="nav-text"> Yazılı Eser İstek </span>
                    </NavLink>
                  </li>
                  <li className="menu no-arrow">
                    <NavLink to="/masal/taleGroupList">
                      <i className="zmdi zmdi-group zmdi-hc-fw" />
                      <span className="nav-text"> Grup Masallar </span>
                    </NavLink>
                  </li>
                  <li className="menu no-arrow">
                    <NavLink to="/masal/announcement">
                      <i className="zmdi zmdi-assignment zmdi-hc-fw" />
                      <span className="nav-text"> Duyuru & Eğitim</span>
                    </NavLink>
                  </li>
                  <li className="menu no-arrow">
                    <NavLink to="/masal/myPastReviews">
                      <i className="zmdi zmdi-assignment zmdi-hc-fw" />
                      <span className="nav-text"> Geçmiş İncelemeler</span>
                    </NavLink>
                  </li>
                  <li className="menu no-arrow">
                    <NavLink to="/masal/ComplatedTalePage">
                      <i className="zmdi zmdi-assignment zmdi-hc-fw" />
                      <span className="nav-text"> Tamamlanan Masallar</span>
                    </NavLink>
                  </li>
                  <li className="menu no-arrow">
                    <NavLink to="/masal/privateContentTalePage">
                      <i className="zmdi zmdi-assignment zmdi-hc-fw" />
                      <span className="nav-text"> Özel İçerik Masallar</span>
                    </NavLink>
                  </li>

                  <li className="menu no-arrow">
                    <NavLink to="/masal/payments">
                      <i className="zmdi zmdi-assignment zmdi-hc-fw" />
                      <span className="nav-text"> Ödeme İşleri</span>
                    </NavLink>
                  </li>

                  {(this.isRoleCheck(userRoles, 7) || this.isRoleCheck(userRoles, 6)) && <li className="menu no-arrow" key="asda2">
                    <NavLink to="/masal/reviewTalePage">
                      <i className="zmdi zmdi-edit zmdi-hc-fw" />
                      <span className="nav-text"> Düzenlenecek Masallar</span>
                    </NavLink>
                  </li>}
                  <li className="menu no-arrow">
                    <NavLink to="/masal/approvedTalePage">
                      <i className="zmdi zmdi-assignment-check zmdi-hc-fw" />
                      <span className="nav-text">  Onaylanan Masallar </span>
                    </NavLink>
                  </li>

                </ul>
              </li>
              ]
              : null
          }



          {
            this.isRoleCheck(userRoles, 1) ?
              [
                <li className="nav-header" key="2">
                  <IntlMessages id="sidebar.writer" />
                </li>,
                (this.isRoleCheck(userRoles, 6) || this.isRoleCheck(userRoles, 13) || this.isRoleCheck(userRoles, 14)) && (
                  <li className="menu no-arrow" key="taleSave">
                    <NavLink to="/masal/taleSave">
                      <i className="zmdi zmdi-email zmdi-hc-fw" />
                      <span className="nav-text"> Masal Gönder </span>
                    </NavLink>
                  </li>
                ),
                <li className="menu no-arrow">
                  <NavLink to="/masal/taleList">
                    <i className="zmdi zmdi-dns zmdi-hc-fw" />
                    <span className="nav-text"> Masallarım </span>
                  </NavLink>
                </li>,
                <li className="menu no-arrow">
                  <NavLink to="/masal/taleListInbox">
                    <i className="zmdi zmdi-star zmdi-hc-fw" />
                    <span className="nav-text"> Bekleyen İşlerim </span>
                  </NavLink>
                </li>,
                // <li className="menu no-arrow">
                //   <NavLink to="/masal/payments">
                //     <i className="zmdi zmdi-money zmdi-hc-fw"/>
                //     <span className="nav-text"> Ödemelerim </span>
                //   </NavLink>
                // </li>


              ]
              : null
          }

          {/* {
       ( this.isRoleCheck(userRoles,9) || this.isRoleCheck(userRoles,6)) &&  [
        <li className="nav-header" key="asda1">
         Editör
        </li>,
       <li className="menu no-arrow" key="asda2">
        <NavLink to="/masal/ComplatedTalePage">
          <i className="zmdi zmdi-assignment zmdi-hc-fw"/>
          <span className="nav-text"> Düzenlenecek Masallar</span>
        </NavLink>
      </li>,
          <li className="menu no-arrow">
          <NavLink to="/masal/privateContentTalePage">
            <i className="zmdi zmdi-assignment zmdi-hc-fw"/>
            <span className="nav-text"> Özel İçerik Masallar</span>
          </NavLink>
        </li>  
    ]
      } */}
         
          <li className="nav-header" >
            Masal Anlatıcılığı Kursu
          </li>
          {
            (this.isRoleCheck(userRoles, 6) || this.isRoleCheck(userRoles, 11)) &&
            <>
              <li className="menu no-arrow">
                <NavLink to="/masal/course">
                  <i className="zmdi zmdi-edit zmdi-hc-fw" />
                  <span className="nav-text">  Yeni Kurs Oluştur </span>
                </NavLink>
              </li>
            </>
          }
          {
            (this.isRoleCheck(userRoles, 6) || this.isRoleCheck(userRoles, 11) || this.isRoleCheck(userRoles, 12)) &&
            <>
              <li className="menu no-arrow">
                <NavLink to="/masal/courseList">
                  <i className="zmdi zmdi-format-list-numbered zmdi-hc-fw" />
                  <span className="nav-text">  Kurs Listesi </span>
                </NavLink>
              </li>
            </>
          }

          <li className="menu no-arrow">
            <NavLink to="/masal/courseApplication">
              <i className="zmdi zmdi-assignment zmdi-hc-fw" />
              <span className="nav-text">  Kurs Başvurusu Yap </span>
            </NavLink>
          </li>

          <li className="menu no-arrow">
            <NavLink to="/masal/myCourses">
              <i className="zmdi zmdi-assignment-check zmdi-hc-fw" />
              <span className="nav-text">  Kurslarım </span>
            </NavLink>
          </li>

          <li className="nav-header" >

          </li>

        </ul>
      </CustomScrollbars>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  const { authUser } = auth;
  return { authUser };
};

export default withRouter(connect(mapStateToProps, {

})(SidenavContent));


